import { Link } from 'react-router-dom';
import { seoArticleCards } from '@/mocks/siteData';

const articleImages: Record<string, string> = {
  'home-article-b1': 'https://readdy.ai/api/search-image?query=Fresh%20modern%20desk%20setup%20with%20open%20laptop%20showing%20tutorial%20interface%2C%20notebook%20with%20handwritten%20notes%2C%20coffee%20cup%20with%20latte%20art%2C%20warm%20afternoon%20sunlight%20through%20blinds%2C%20wooden%20desk%2C%20cozy%20home%20office%20vibe&width=600&height=400&seq=home-art-b1&orientation=landscape',
  'home-article-b2': 'https://readdy.ai/api/search-image?query=Clean%20financial%20desk%20with%20calculator%20and%20laptop%20displaying%20pricing%20charts%2C%20glass%20of%20water%20with%20lemon%2C%20small%20succulent%2C%20bright%20natural%20side%20lighting%2C%20oak%20desk%2C%20modern%20minimalist&width=600&height=400&seq=home-art-b2&orientation=landscape',
  'home-article-b3': 'https://readdy.ai/api/search-image?query=Modern%20security%20workspace%20with%20lock%20icon%20on%20laptop%20screen%2C%20small%20brass%20padlock%20on%20wooden%20desk%2C%20warm%20desk%20lamp%20light%2C%20dark%20walnut%20surface%2C%20professional%20atmosphere%2C%20soft%20background%20bokeh&width=600&height=400&seq=home-art-b3&orientation=landscape',
  'home-article-b4': 'https://readdy.ai/api/search-image?query=Split%20desk%20scene%20with%20organized%20spreadsheet%20on%20one%20monitor%20and%20cluttered%20browser%20on%20another%2C%20warm%20natural%20lighting%2C%20white%20desk%2C%20artistic%20comparison%20concept&width=600&height=400&seq=home-art-b4&orientation=landscape',
  'home-article-b5': 'https://readdy.ai/api/search-image?query=Elegant%20workspace%20with%20dual%20monitor%20setup%20displaying%20analytics%2C%20mechanical%20keyboard%20with%20warm%20backlight%2C%20premium%20headphones%2C%20afternoon%20sunlight%2C%20matte%20black%20desk%2C%20professional%20setup&width=600&height=400&seq=home-art-b5&orientation=landscape',
  'home-article-b6': 'https://readdy.ai/api/search-image?query=Modern%20tech%20comparison%20with%20tablet%20and%20laptop%20showing%20different%20interfaces%20on%20light%20marble%20desk%2C%20coffee%20mug%2C%20monstera%20plant%2C%20bright%20clean%20lighting%2C%20minimalist%20aesthetic&width=600&height=400&seq=home-art-b6&orientation=landscape',
  'home-article-b7': 'https://readdy.ai/api/search-image?query=Wide%20desk%20with%20multiple%20product%20catalog%20printouts%20and%20laptop%20showing%20bulk%20order%20spreadsheet%2C%20calculator%2C%20warm%20overhead%20lighting%2C%20organized%20professional%20setup%2C%20oak%20desk&width=600&height=400&seq=home-art-b7&orientation=landscape',
  'home-article-b8': 'https://readdy.ai/api/search-image?query=Helpful%20support%20workspace%20with%20laptop%20displaying%20FAQ%20interface%2C%20notebook%20with%20checklist%2C%20warm%20tea%20in%20glass%20mug%2C%20cozy%20home%20office%20with%20bookshelf%2C%20gentle%20window%20light&width=600&height=400&seq=home-art-b8&orientation=landscape',
  'home-article-b9': 'https://readdy.ai/api/search-image?query=Smartphone%20held%20in%20hand%20displaying%20shopping%20interface%20with%20product%20thumbnails%2C%20cozy%20coffee%20shop%20background%2C%20oat%20milk%20latte%20on%20wooden%20table%2C%20casual%20lifestyle%2C%20soft%20cafe%20lighting&width=600&height=400&seq=home-art-b9&orientation=landscape',
};

export default function SeoArticlesSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs text-foreground-500 font-medium uppercase tracking-widest mb-3">
            In-Depth SEO Guides
          </p>
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950">
            Mulebuy Spreadsheet
            <br />
            <span className="italic font-light text-primary-500">Knowledge Base</span>
          </h2>
          <p className="text-sm text-foreground-600 mt-4 max-w-xl leading-relaxed">
            Explore our collection of detailed mulebuy spreadsheet guides covering everything from beginner tutorials to advanced bulk ordering strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {seoArticleCards.map((article) => (
            <Link
              key={article.seq}
              to={article.slug}
              className="group block rounded-xl overflow-hidden bg-background-50 hover:shadow-md transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={articleImages[article.seq]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`Mulebuy Spreadsheet - ${article.title}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-xs text-white/70 bg-black/30 px-2 py-0.5 rounded-full">
                    Mulebuy Guide
                  </span>
                </div>
              </div>
              <div className="px-4 py-4">
                <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors mb-1.5 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {article.subtitle}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs font-medium text-primary-500">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/mulebuy-spreadsheet-complete-guide"
            className="inline-flex px-7 py-3 bg-primary-500 text-background-50 rounded-md font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            View All Mulebuy Spreadsheet Guides
          </Link>
        </div>
      </div>
    </section>
  );
}